import { TileConfig } from './types';

export const GRID_SIZE = 4;
export const WIN_VALUE = 2048;
export const LEVEL_ID = 'alien2048';

// Preload all tile images on module load
const preloadImages = () => {
  const imagePaths = [
    '/images/heads/1078.png',  // 2
    '/images/heads/2265.png',  // 4
    '/images/heads/7419.png',  // 8
    '/images/heads/357.png',   // 16
    '/images/heads/7235.png',  // 32
    '/images/heads/9077.png',  // 64
    '/images/heads/1097.png',  // 128
    '/images/heads/3084.png',  // 256
    '/images/heads/7423.png',  // 512
    '/images/heads/7146.png',  // 1024
    '/images/heads/4707.png',  // 2048+
  ];

  imagePaths.forEach(path => {
    const img = new Image();
    img.src = path;
  });
};

// Run preload immediately
if (typeof window !== 'undefined') {
  preloadImages();
}

// Tile configurations mapping value to character/style
export const TILE_CONFIGS: Record<number, TileConfig> = {
  2: {
    name: 'Mfer',
    image: '/images/heads/1078.png',
    backgroundColor: '#eee4da',
    textColor: '#776e65'
  },
  4: {
    name: 'Cowboy',
    image: '/images/heads/2265.png',
    backgroundColor: '#ede0c8',
    textColor: '#776e65'
  },
  8: {
    name: 'Hoodie',
    image: '/images/heads/7419.png',
    backgroundColor: '#94c447',
    textColor: '#000000'
  },
  16: {
    name: 'Zombie',
    image: '/images/heads/357.png',
    backgroundColor: '#94c447',
    textColor: '#f9f6f2'
  },
  32: {
    name: 'Ape mfer',
    image: '/images/heads/7235.png',
    backgroundColor: '#8b4513',
    textColor: '#f9f6f2'
  },
  64: {
    name: 'Alien',
    image: '/images/heads/9077.png',
    backgroundColor: '#00ff00',
    textColor: '#000000'
  },
  128: {
    name: 'Gold Alien',
    image: '/images/heads/1097.png',
    backgroundColor: '#ffd700',
    textColor: '#776e65'
  },
  256: {
    name: 'Diamond',
    image: '/images/heads/3084.png',
    backgroundColor: '#00ffff',
    textColor: '#776e65'
  },
  512: {
    name: 'Rainbow',
    image: '/images/heads/7423.png',
    backgroundColor: '#ff69b4',
    textColor: '#f9f6f2'
  },
  1024: {
    name: 'Cosmic',
    image: '/images/heads/7146.png',
    backgroundColor: '#9400d3',
    textColor: '#f9f6f2'
  },
  2048: {
    name: 'LEGEND',
    image: '/images/heads/4707.png',
    backgroundColor: '#ff0000',
    textColor: '#f9f6f2'
  }
};

// Default config for tiles beyond 2048
export const DEFAULT_TILE_CONFIG: TileConfig = {
  name: 'Beyond',
  image: '/images/heads/4707.png',
  backgroundColor: '#3c3a32',
  textColor: '#f9f6f2'
};

// Get tile config by value
export function getTileConfig(value: number): TileConfig {
  return TILE_CONFIGS[value] || DEFAULT_TILE_CONFIG;
}

// Emoji mapping for sharing
export const TILE_EMOJIS: Record<number, string> = {
  2: '😐',
  4: '🤠',
  8: '🧥',
  16: '🧟',
  32: '🟫',
  64: '👽',
  128: '✨',
  256: '💎',
  512: '🌈',
  1024: '🌌',
  2048: '🔥'
};

export function getTileEmoji(value: number): string {
  return TILE_EMOJIS[value] || '🎮';
}

export function getTileName(value: number): string {
  return TILE_CONFIGS[value]?.name || `${value}`;
}

// Local storage keys
export const STORAGE_KEYS = {
  BEST_SCORE: 'alien2048_best_score',
  GAME_STATE: 'alien2048_game_state'
};

// Audio paths for directional movement
export const AUDIO_PATHS = {
  MOVE_UP: '/audio/correct.mp3',
  MOVE_DOWN: '/audio/correct.mp3',
  MOVE_LEFT: '/audio/correct.mp3',
  MOVE_RIGHT: '/audio/correct.mp3',
  MERGE: '/audio/success.mp3',
  INVALID: '/audio/wrong_sound.mp3'
};

// Background music - TVARI tracks (randomly selected)
export const BACKGROUND_MUSIC = [
  '/audio/alien2048/tvari-forever-love.mp3',
  '/audio/alien2048/tvari-revive.mp3',
  '/audio/alien2048/tvari-way.mp3'
];
